import React from 'react';
import './About.css';
import { useTheme } from '../context/ThemeContext';
import navyLogo from '../assets/images/logo_icon_navy_transparent_hd.png';
import goldenLogo from '../assets/images/logo_icon_golden_transparent_hd.png';

const About = () => {
  const { theme } = useTheme();
  const logo = theme === 'dark' ? goldenLogo : navyLogo;

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="about-content">
          <div className="about-image">
            <img src={logo} alt="Jasar Institute" className="institute-logo" />
          </div>
          
          <div className="about-text">
            <p className="about-description">
              Jasar Institute is an initiative by <strong><a href="https://www.amongislam.com" target="_blank" rel="noopener noreferrer" className="amongislam-link">AmongIslam Organization</a></strong> to bring 
              Islamic education into daily life through fast, easy, and modern methods. We are an 
              institute built by professionals, Islamic scholars, and professors who have expertise 
              and certification in Islamic teachings.
            </p>
            
            <div className="about-features">
              <div className="feature-card">
                <div className="feature-icon">📚</div>
                <h3>Professional Team</h3>
                <p>Built by certified professionals and scholars</p>
              </div>
              
              <div className="feature-card">
                <div className="feature-icon">⚡</div>
                <h3>Fast & Easy</h3>
                <p>Modern methods for efficient learning</p>
              </div>
              
              <div className="feature-card">
                <div className="feature-icon">🎓</div>
                <h3>Certified Expertise</h3>
                <p>Professors with proven Islamic knowledge</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
